import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';

// project imports
import useAuth from 'hooks/useAuth';
import NoClinicAccessPage from 'views/access/noClinicAccessPage';

// ==============================|| CLINIC ACCESS GUARD ||============================== //

/**
 * Guard for /clinic/:clinicId/... routes. Grants are already in memory from
 * /me, so the check needs no request and a page for an ungranted clinic is
 * never rendered (its data requests would all 403 against the URL's clinic).
 * @param {PropTypes.node} children children element/node
 */
const ClinicAccessGuard = ({ children }) => {
    const { clinicId } = useParams();
    const { clinicGrants } = useAuth();

    if (!clinicGrants?.[clinicId]) {
        return <NoClinicAccessPage />;
    }

    return children;
};

ClinicAccessGuard.propTypes = {
    children: PropTypes.node
};

export default ClinicAccessGuard;
